const PaymentLoadingModal = ({ isOpen, type = "loading" }) => {
  if (!isOpen) return null;

  return (
    <div className="pm-overlay">
      <div className="pm-modal">

        {/* --- SHOW SPINNER WHEN PROCESSING PAYMENT --- */}
        {type === "loading" && (
          <>
            {/* <div className="spinnerPay">
              {Array.from({ length: 12 }).map((_, i) => (
                <div key={i}></div>
              ))}
            </div> */}

            <div className="spinnerPay">
              <img src="/images/loading-loading-gif.gif" alt="Cancelled" />
            </div>

            <h3>
              Just a moment!
            </h3>

            <p>
              We are securely processing your payment.<br />
              Please do not click back or refresh while this is in progress.
              
            </p>
          </>
        )}

        {/* --- SHOW CANCELLATION PROCESS UI --- */}
        {type === "cancelling" && (
          <>
            <div className="cancel-icon">
              <img src="/images/cancelbookings.gif" alt="Cancelled" />
            </div>

            <h3>Cancelling your booking...</h3>

            <p>
              Everything is being handled securely.<br />
              You’ll be notified when it's complete.
            </p>
          </>
        )}

      </div>
    </div>
  );
};

export default PaymentLoadingModal;
